import { render, staticRenderFns } from "./VisionboardOverviewPage.vue?vue&type=template&id=414aaef3&"
import script from "./VisionboardOverviewPage.vue?vue&type=script&lang=js&"
export * from "./VisionboardOverviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports